 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		29: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		29: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"configurator-projects~find-your-flooring~product~product-mobile","1":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile~product","2":"configurator-projects~product~product-mobile","3":"fbr~feature-based-recommendations~ratings-and-reviews","4":"find-your-flooring~product~product-mobile","5":"add-to-list-drawer","6":"fbr","7":"media-gallery-filmstrip-mobile~media-gallery-overlay-mobile","8":"media-gallery-overlay-mobile~ratings-and-reviews","9":"overlay~ratings-and-reviews","10":"questions-and-answers~ratings-and-reviews","11":"common","12":"configurator-projects","13":"customer-image-overlay","14":"feature-based-recommendations","15":"find-your-flooring","16":"hammerjs","17":"home","18":"media-gallery-filmstrip-mobile","19":"media-gallery-overlay","20":"media-gallery-overlay-mobile","22":"order-sample-drawer","23":"overlay","24":"product","25":"product-mobile","26":"product-overview","27":"questions-and-answers","28":"ratings-and-reviews","30":"share-to-email-overlay","31":"share-to-pinterest-overlay","32":"size-guide-overlay","33":"specifications","35":"video-player"}[chunkId]||chunkId) + "." + {"0":"3730d09e7c57e13acbb9","1":"c17e8711726a998b9473","2":"2be171172cf8e97f0b65","3":"c0517892158bcab5403b","4":"48067809a2feed2115ad","5":"67290b25c7fd7e1f09dd","6":"4aa957876ae182ad77cd","7":"5417f6e7f1fbb9639540","8":"9dac7ff8a0d17136c71d","9":"6638e90eba609ac83aae","10":"1667f85c67166c29c8b5","11":"dc4d895e89f879cb825a","12":"0c49d9ecd3686c5cf157","13":"39feb547a0fac07ccbcc","14":"c0547ecb76d957feb5f8","15":"a54037868a8a17638899","16":"6f0796ff8f983adb819b","17":"e6ea72f12e64b7d7fbca","18":"fa0bc4113c4d0b12e3fb","19":"8053609db90174938854","20":"e03c9bca03016dc1b41c","22":"f6bf29c207e802963b7c","23":"06627fd7a9cc340f8766","24":"deea89808a6599d4e44d","25":"fd23f87dc7b88654610a","26":"b6d2f4c025846a223de4","27":"7b415f702738aa341f0a","28":"e4484fe1c5929b419426","30":"ba76288724dbf0798dcc","31":"35a093ef40ccdae4f817","32":"247a728611863bdf1508","33":"af5018bea117b660248e","35":"a264240a04628dfc24c4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"3":1,"6":1,"8":1,"9":1,"10":1,"13":1,"14":1,"18":1,"19":1,"20":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"configurator-projects~find-your-flooring~product~product-mobile","1":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile~product","2":"configurator-projects~product~product-mobile","3":"fbr~feature-based-recommendations~ratings-and-reviews","4":"find-your-flooring~product~product-mobile","5":"add-to-list-drawer","6":"fbr","7":"media-gallery-filmstrip-mobile~media-gallery-overlay-mobile","8":"media-gallery-overlay-mobile~ratings-and-reviews","9":"overlay~ratings-and-reviews","10":"questions-and-answers~ratings-and-reviews","11":"common","12":"configurator-projects","13":"customer-image-overlay","14":"feature-based-recommendations","15":"find-your-flooring","16":"hammerjs","17":"home","18":"media-gallery-filmstrip-mobile","19":"media-gallery-overlay","20":"media-gallery-overlay-mobile","22":"order-sample-drawer","23":"overlay","24":"product","25":"product-mobile","26":"product-overview","27":"questions-and-answers","28":"ratings-and-reviews","30":"share-to-email-overlay","31":"share-to-pinterest-overlay","32":"size-guide-overlay","33":"specifications","35":"video-player"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"33821f5d5d309dd9d04b","2":"31d6cfe0d16ae931b73c","3":"feaf045e3a3f955c2289","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"d806b3b4bdcf734dbe7b","7":"31d6cfe0d16ae931b73c","8":"83588448fb37280fe4ec","9":"b0b4eb1ed9d9c6208a14","10":"84648804ec7cb24cad1a","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"c466036523aec2558c34","14":"7fa4a6a0fe75eb189dbe","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"e07956ac4ef9facbea2e","19":"655ffd4b6ecb8760e4bc","20":"8d2f988ae4bb7ad7c55d","22":"31d6cfe0d16ae931b73c","23":"359d9860af00d3a57871","24":"1cbc7e28fcb36bf56e72","25":"2b9274665622d0ef3656","26":"d473553eeb371b166c5f","27":"bfe9f79e2c02dc48bc7c","28":"9e90f8d317e76b47090e","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/non-buyable-services/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
